export default __webpack_public_path__ + "static/media/bonus2.dba7a2fd.mov";